module.exports = __webpack_public_path__ + "static/img/020政府建设专栏9.d96e240.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/020政府建设专栏9.jpg
// module id = e4R4
// module chunks = 0